// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_2ZJ6O","visuallyhidden":"_3b7dY","hide-text":"FMlma","center":"_1ewY0","noprint":"_1mWEY","map":"_1k1Qs"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-map/styles/Map.scss
 ** module id = 949
 ** module chunks = 1
 **/